export const environment = {
	appRoot: "https://test.kompass.space",
	authRoot: "https://auth.kompass.space",
	authUiRoot: "https://auth.kompass.space/ui",
	gameApiRoot: "https://api.kompass.space",
};